import { render, staticRenderFns } from "./AccountButton.vue?vue&type=template&id=5218eac6&scoped=true"
import script from "./AccountButton.vue?vue&type=script&lang=js"
export * from "./AccountButton.vue?vue&type=script&lang=js"
import style0 from "./AccountButton.vue?vue&type=style&index=0&id=5218eac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5218eac6",
  null
  
)

export default component.exports